<template>
	<page enable-flex :create-button="auth('b_app_asset_repair_edit')" @create="addHandle">
		<view-list work-type="16" view-id="10016" :search="{placeholder: '搜单据编号'}">
			<template #default="{data, index}">
				<view-doc-card :key="index" type="16" :data="data">
					<template #base_state>
						<c-state dict="repairStatusDic" tag :value="data.status"></c-state>
					</template>

					<!--维修类型-->
					<template #repair_type>
						<c-state dict="repairTypeDic" :value="data.repair_type"></c-state>
					</template>
				</view-doc-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_asset_repair',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/assets/repair/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>